// extracted by mini-css-extract-plugin
export default {"loading-spinner":"loading_loading-spinner__sH5A5"};